// src/screens/sales/document/Document.tsx
import React from 'react'
import classes from './Document.module.sass'
import { Helmet } from 'react-helmet-async'
import { Button } from '../../../common/components/button/Button'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useDocument } from './hooks/useDocument'
import Search from '../../../common/components/listControl/search/Search'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'

export const Document = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    download,
    getPreviewUrl,
    currentFileUrl,
  } = useDocument()

  const {
    searchQuery,
    handleSearch,
    clearSearch,
    filteredItems: filteredList,
  } = useSearchWithDebounce({
    items: list,
    searchFields: ['id', 'name', 'description'],
  })

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Документы`}</title>
        <meta name="description" content={`Справочник документов`} />
      </Helmet>

      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`документы`}</div>
        <Button onClick={startCreate} text="Загрузить" />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по id, названию или описанию"
        />
      </div>

      <List
        showDetails={showDetails}
        startEdit={startEdit}
        list={filteredList}
        loading={loading}
        onDownload={download}
        getPreviewUrl={getPreviewUrl}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} fileUrl={currentFileUrl} onDownload={download} />
      </Modal>
    </div>
  )
}
